import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import { ENDPOINTS } from '../app.config';
import Utils from '../app.utilities';
import {CompanyService} from '../company.service';
import { UserInfoService } from '../shared/user-info.service';
import { TranslateService } from '@ngx-translate/core';

const utilities = new Utils();

@Component({
  selector: 'app-channels',
  templateUrl: './channels.component.html',
  styleUrls: ['./channels.component.css'],
  // Is already provided in ../app.module.ts
  //  but the UserInfoService, in the constructor, needs access to ActivatedRoute.params
  //  https://stackoverflow.com/questions/39977962/angular-2-0-2-activatedroute-is-empty-in-a-service
  providers: [UserInfoService]
})
export class ChannelsComponent implements OnInit {
  channelName: string;
  channelNameError: boolean;
  channelDescription: string;
  channelDescriptionError: boolean;
  channels: any;
  companyId: any;
  company: any;
  companyName : string;
  sub: any;
  userRole: string;
  companyService: CompanyService;
  userInfoService : UserInfoService;
  toaster: ToasterService;
  route: ActivatedRoute;
  editingChannel: any;
  deletingChannel: any;
  businesOwnerName : string;
  businessOwnerIdLocalStorage = localStorage.getItem('businessOwnerId');

  // Messages
  error_loading_the_company: string;
  channel_upload_error: string;
  error_adding_channel: string;
  channel_successfully_added: string;
  successfully_saved: string;

  constructor
  (
    toaster: ToasterService,
    route: ActivatedRoute,
    companyService: CompanyService,
    userInfoService : UserInfoService,
    private translate: TranslateService,
  ) {
    this.channelName = '';
    this.channelDescription = ''
    this.channelNameError = false;
    this.channelDescriptionError = false;
    this.toaster = toaster;
    this.route = route;
    this.companyService = companyService;
    this.userInfoService = userInfoService;
  }

  ngOnInit() {
    this.sub = this.route
      .params
      .subscribe(params => {
        this.companyId = params.companyId;
        this.companyService.setCompanyId(this.companyId);
        this.getChannels();
        this.getCompanyInfo();
        this.getUserInfo();
      });

    // Messages translations
    this.translate.stream('SHARED.Messages.error_loading_the_company').subscribe((res: string) => {
      this.error_loading_the_company = res;
    });
    this.translate.stream('SHARED.Messages.channel_upload_error').subscribe((res: string) => {
      this.channel_upload_error = res;
    });
    this.translate.stream('SHARED.Messages.error_adding_channel').subscribe((res: string) => {
      this.error_adding_channel = res;
    });
    this.translate.stream('SHARED.Messages.channel_successfully_added').subscribe((res: string) => {
      this.channel_successfully_added = res;
    });
    this.translate.stream('SHARED.Messages.successfully_saved').subscribe((res: string) => {
      this.successfully_saved = res;
    });
  }

  getCompanyInfo() {
    const _self = this;
    axios
      .get(ENDPOINTS.GET_COMPANIES + '/' + this.companyId)
      .then(
        response => {
          _self.company = response.data;
        },
        error => {
          this.toaster.pop('error', this.error_loading_the_company);
        },
      );
  }

  getChannels() {
    const _self = this;
    axios
      .get(ENDPOINTS.GET_CHANNELS.replace(':companyId', this.companyId))
      .then(
        response => {
          _self.channels = response.data;
        },
        error => {
          this.toaster.pop('error', this.channel_upload_error);
        },
      );
  }

  getUserInfo() {
    const _self = this;
    this.userInfoService.getInformations()
      .subscribe(
        userInfo => {
          _self.userRole         = userInfo.userRole;
          _self.companyName      = userInfo.companyName;
          _self.businesOwnerName = userInfo.businesOwnerName;
        },
         error => {
           this.toaster.pop('error', this.channel_upload_error);
         }
    );
  }


  addNewChannel() {
    const _self = this;
    _self.channelNameError = false;
    _self.channelDescriptionError = false;
    if (_self.channelName === '') {
      return (_self.channelNameError = true);
    }

    axios
      .post(ENDPOINTS.ADD_CHANNEL.replace(':companyId', this.companyId), {
        name: _self.channelName,
        description: _self.channelDescription,
      })
      .then(
        response => {
          _self.toaster.pop('success', this.channel_successfully_added);
          _self.channelName = '';
          _self.channelDescription = '';
          _self.getChannels();
        },
        error => {
          _self.toaster.pop('error', this.error_adding_channel);
        },
      );
  }

  editChannel(channel) {
    this.editingChannel = channel;
    this.channelName = channel.name;
    this.channelDescription = channel.description;
  }

  updateChannel() {
    const _self = this;
    _self.channelNameError = false;
    _self.channelDescriptionError = false;
    if (_self.channelName === '') {
      return (_self.channelNameError = true);
    }

    axios
      .put(ENDPOINTS.GET_CHANNELS.replace(':companyId', this.companyId) + '/' + this.editingChannel.id, {
        name: _self.channelName,
        description: _self.channelDescription,
      })
      .then(
        response => {
          _self.channelName = '';
          _self.channelDescription = '';
          _self.getChannels();

          _self.cancelEdit();
          _self.toaster.pop('success', this.successfully_saved);
        },
        error => {
          _self.toaster.pop('error', this.error_adding_channel);
          _self.cancelEdit();
        },
      );
  }

  deleteChannel(channelId: number) {
    const _self = this;

    axios
      .delete(ENDPOINTS.DELETE_CHANNEL.replace(':companyId', this.companyId).replace(':id', `${channelId}`))
      .then(
        response => {
          _self.channelName = '';
          _self.channelDescription = '';
          _self.cancelEdit();
          _self.getChannels();
        },
        error => {
          _self.toaster.pop('error', this.error_adding_channel);
          _self.cancelEdit();
        },
      );
  }

  cancelEdit() {
    const _self = this;
    _self.channelNameError = false;
    _self.channelDescriptionError = false;

    _self.channelName = '';
    _self.channelDescription = '';

    _self.editingChannel = null;
  }

  openModal(modal, channel: any) {
    this.cancelEdit();
    this.deletingChannel = channel;
    modal.open();
  }
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/channels/channels.component.ts